export default "__VITE_ASSET__BLeipz8q__"